import { AssessmentDamageListElement } from "../../../system/Domain";

// A manually added goodwill line is a pure discount: it only affects notForCustomer and finalCustomerBill (reduces it) and is never partially depreciated.
// Replicated in the backend (AssessmentDamageListElement.IsManualGoodwill)!
export const isManualGoodwill = (d: AssessmentDamageListElement) => !!d.isNew && d.bookingCode?.key === "RS06";
export const effectiveFactor = (d: AssessmentDamageListElement) => isManualGoodwill(d) ? 1 : d.factor;
